import { render, staticRenderFns } from "./LastChance.vue?vue&type=template&id=38cae2ea&"
import script from "./LastChance.vue?vue&type=script&lang=js&"
export * from "./LastChance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports